import { Route } from 'react-router-dom';
import { UserList } from './list';
import { UserShow } from './show';

export const UsersRoute = (
  <Route path="users">
    <Route index element={<UserList />} />
    <Route path=":id" element={<UserShow />} />
  </Route>
);
